import type { CopilotTabKey } from "../types";

export const COPILOT_DEFAULT_PAGE_SIZE = 10;

export const COPILOT_TAB_OPTIONS: Array<{ key: CopilotTabKey; label: string }> =
	[
		{ key: "all", label: "Todos" },
		{ key: "reminders", label: "Lembretes" },
		{ key: "alerts", label: "Alertas" },
		{ key: "opportunities", label: "Oportunidades" },
	];

/** Alinhar a `PRIORITY_CARD_COPILOT_TAB_QUERY_PARAM` em `shared/constants/priority-cards.constants.ts`. */
export const COPILOT_TAB_QUERY_PARAM = "tab";

/** Valores alinhados ao contrato da API de listagem de insights */
export const COPILOT_LIST_STATUS = {
	ALL: 0,
	RESOLVED: 1,
	PENDING: 2,
} as const;

export const COPILOT_LIST_STATUS_OPTIONS = [
	{ id: COPILOT_LIST_STATUS.ALL, label: "Todos", isDisabled: false },
	{ id: COPILOT_LIST_STATUS.PENDING, label: "Pendentes", isDisabled: false },
	{ id: COPILOT_LIST_STATUS.RESOLVED, label: "Resolvidos", isDisabled: false },
];
